import SimpleBar from "simplebar";

class SimpleBarScroll {
  constructor(selector = ".js-simplebar", options = {}) {
    this.selector = selector;

    this.options = {
      autoHide: false,
      forceVisible: "x",
      ...options,
    };

    this.instances = [];
    this.resizeTimer = null;

    this.mediaQuery = window.matchMedia("(max-width: 767px)");

    this.handleMediaChange = this.handleMediaChange.bind(this);
    this.handleResize = this.handleResize.bind(this);

    this.init();
  }

  init() {
    this.update();
    this.bindEvents();
  }

  bindEvents() {
    this.mediaQuery.addEventListener("change", this.handleMediaChange, false);

    window.addEventListener("resize", this.handleResize, false);
  }

  handleMediaChange() {
    this.update();
  }

  handleResize() {
    window.clearTimeout(this.resizeTimer);

    this.resizeTimer = window.setTimeout(() => {
      this.update();

      if (this.isMobile()) {
        this.recalculate();
      }
    }, 200);
  }

  update() {
    if (this.isMobile()) {
      this.mount();
    } else {
      this.destroy();
    }
  }

  isMobile() {
    return this.mediaQuery.matches;
  }

  mount() {
    const elements = document.querySelectorAll(this.selector);

    if (!elements.length) return;

    elements.forEach((element) => {
      if (element.dataset.simplebarInitialized === "true") return;

      const instance = new SimpleBar(element, this.options);

      element.dataset.simplebarInitialized = "true";

      this.instances.push({
        element,
        instance,
      });
    });
  }

  recalculate() {
    if (!this.instances.length) return;

    this.instances.forEach(({ instance }) => {
      if (instance && typeof instance.recalculate === "function") {
        instance.recalculate();
      }
    });
  }

  destroy() {
    if (!this.instances.length) return;

    this.instances.forEach(({ element, instance }) => {
      const contentElement =
        instance && typeof instance.getContentElement === "function"
          ? instance.getContentElement()
          : null;

      if (instance && typeof instance.unMount === "function") {
        instance.unMount();
      }

      /**
       * SimpleBarが生成したwrapperの中身を元の要素へ戻す
       */
      if (contentElement) {
        const fragment = document.createDocumentFragment();

        while (contentElement.firstChild) {
          fragment.appendChild(contentElement.firstChild);
        }

        element.innerHTML = "";
        element.appendChild(fragment);
      }

      delete element.dataset.simplebarInitialized;

      this.removeSimpleBarClasses(element);
    });

    this.instances = [];
  }

  removeSimpleBarClasses(element) {
    const classNames = Array.from(element.classList);

    classNames.forEach((className) => {
      if (className.startsWith("simplebar-")) {
        element.classList.remove(className);
      }
    });
  }

  unbindEvents() {
    this.mediaQuery.removeEventListener(
      "change",
      this.handleMediaChange,
      false,
    );
    window.removeEventListener("resize", this.handleResize, false);
  }

  destroyAll() {
    window.clearTimeout(this.resizeTimer);

    this.destroy();
    this.unbindEvents();
  }
}

export default SimpleBarScroll;
